// Dashboard.js
//import React, { useState, useEffect, useContext } from "react";
import React, { useState, useEffect, useCallback } from "react";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
//import htmlDocx from "html-docx-js";

import "./App.css";
const API_URL = process.env.REACT_APP_API_URL;
export default function Dashboard() {
//function App() {
  // ================= STATE =================
  const [students, setStudents] = useState([]);

  const [Domain, setDomain] = useState("");
  const [Skill, setSkill] = useState("");
  const [Degree, setDegree] = useState("");
  const [Location, setLocation] = useState("");

  const [Degreees, setDegreees] = useState([]);
  const [Locations, setLocations] = useState([]);

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [summaries, setSummaries] = useState({});
  // ✅ ADD THIS LINE RIGHT HERE
const [jobDescription, setJobDescription] = useState("");
  // ⭐ ATS STATE ADDED
  const [atsResults, setAtsResults] = useState({});

  // ================= FETCH STUDENTS =================
  const fetchStudents = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        Domain,
        Skill,
        Degree,
        Location,
        page,
        pageSize,
      });
    
const res = await fetch(`${API_URL}/api/students?${params.toString()}`);
    //  const res = await fetch(`/api/students?${params.toString()}`);
      const data = await res.json();

      setStudents(data.students || []);
      setTotalPages(data.totalPages || 1);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  }, [Domain, Skill, Degree, Location, page, pageSize]);

  // ================= DROPDOWNS =================
  const fetchDegreees = useCallback(async () => {
    //const res = await fetch("/api/Degreees");
    const res = await fetch(`${API_URL}/api/degreees`);
    const data = await res.json();
    setDegreees(data.Degreees || []);
  }, []);

  const fetchLocations = useCallback(async () => {
    //const res = await fetch("/api/Locations");
    const res = await fetch(`${API_URL}/api/Locations`);
    const data = await res.json();
    setLocations(data.Locations || []);
  }, []);

  useEffect(() => {
    fetchDegreees();
    fetchLocations();
    fetchStudents();
  }, [fetchDegreees, fetchLocations, fetchStudents]);

  // ================= AI SUMMARY =================
  const generateSummary = useCallback(async (student, index) => {
    setSummaries((prev) => {
      if (prev[index]) return prev;
      fetch(`${API_URL}/api/generate-summary`, {
      //fetch("/api/generate-summary", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student }),
      })
        .then((res) => res.json())
        .then((data) => {
          setSummaries((p) => ({
            ...p,
            [index]: data.summary,
          }));
        })
        .catch(console.error);

      return prev;
    });
  }, []);

  useEffect(() => {
    students.forEach((s, i) => generateSummary(s, i));
  }, [students, generateSummary]);
//
 // ================= PAGE SCROLL FIX =================
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  // ================= ⭐ ATS ENGINE =================
  const calculateATS = (student) => {
    let score = 0;
    let suggestions = [];

    const skill = (student.Skill || "").toLowerCase();
    const domain = (student.Domain || "").toLowerCase();
    const degree = (student.Degree || "").toLowerCase();

    // Skills check
    if (skill.length > 20) score += 30;
    else suggestions.push("Add more technical skills");

    // Domain check
    if (domain.length > 10) score += 20;
    else suggestions.push("Define clear career domain");

    // Degree check
    if (degree.length > 5) score += 15;
    else suggestions.push("Improve education details");

    // Keyword bonus
    const keywords = ["react", "node", "python", "sql", "ai", "ml", "api"];
    let hits = 0;

    const text = `${skill} ${domain}`;
    keywords.forEach((k) => {
      if (text.includes(k)) hits++;
    });

    score += hits * 5;

    if (hits < 3) {
      suggestions.push("Add industry keywords like React, Python, SQL");
    }

    return {
      score: Math.min(score, 100),
      suggestions,
    };
  };

  // ⭐ AUTO ATS CALCULATION
 
const calculateATSScore2 = (student = {}, jd = "") => {
  if (!jd.trim()) {
    return { score: 0, suggestions: ["Download Resume for Edit"] };
  }
  const stopWords = new Set([
    "the","is","a","an","and","or","to","of","in","for","with",
    "we","are","looking","candidate","role","work","on","our",
    "will","be","this","that","you","your","as","at"
  ]);
  const jdText = jd.toLowerCase();
  const jdKeywords = jdText
    .replace(/[^a-zA-Z0-9 ]/g, " ")
    .split(" ")
    .filter(w => w.length > 2)
    .filter(w => !stopWords.has(w));

  let score = 0;

  jdKeywords.forEach((word) => {
    if (student.Skill?.toLowerCase().includes(word)) score += 3;
    else if (student.Domain?.toLowerCase().includes(word)) score += 2;
    else if (student.Degree?.toLowerCase().includes(word)) score += 1;
  });

  const maxScore = jdKeywords.length * 3;

  const finalScore = maxScore
    ? Math.round((score / maxScore) * 100)
    : 0;

  return {
    score: finalScore,
    suggestions:
      finalScore < 40
        ? ["Improve JD keyword alignment", "Add missing skills"]
        : [],
  };
};
useEffect(() => {
  const results = {};

  (students || []).forEach((s, i) => {
    const res1 = calculateATS(s || {});
    const res2 = calculateATSScore2(s || {}, jobDescription || "");

    results[i] = {
      score1: res1?.score ?? 0,
      suggestions1: res1?.suggestions ?? [],

      score2: res2?.score ?? 0,
      suggestions2: res2?.suggestions ?? [],
    };
  });

  setAtsResults(results);
}, [students, jobDescription]);

//Download Word
const downloadWord = (student, index) => {
  const ats = atsResults[index] || {};

  const htmlContent = `
    <html>
      <head>
        <meta charset="utf-8">
        <title>Resume</title>
      </head>
      <body style="font-family: Arial;">

        <h1>${student?.Name || "Student"}</h1>
        <p><b>Location:</b> ${student?.Location || ""}</p>

        <h2>Profile</h2>
        <p>${student?.Domain || ""}</p>

        <h2>Skills</h2>
        <p>${student?.Skill || ""}</p>

        <h2>Education</h2>
        <p>${student?.Degree || ""}</p>

        <h2>AI Summary</h2>
        <p>${summaries[index] || ""}</p>

        <hr/>

        <h2>Complete Resume Details</h2>
        ${Object.entries(student || {})
          .map(([k, v]) => `<p><b>${k}:</b> ${v}</p>`)
          .join("")}

      </body>
    </html>
  `;

  const converted = htmlDocx.asBlob(htmlContent);
  saveAs(converted, `${student?.Name || "resume"}.doc`);
};

//
  // ================= PDF GENERATOR (MULTI-PAGE SAFE) =================
  const generatePDF = (student, index) => {
    const doc = new jsPDF();

    let y = 15;
    const pageHeight = 280;
    const pageWidth = 180;

    const checkPageBreak = (h = 10) => {
      if (y + h > pageHeight) {
        doc.addPage();
        y = 15;
      }
    };

    const addBlock = (title, content) => {
      if (!content) return;

      const lines = doc.splitTextToSize(String(content), pageWidth);
      const blockHeight = lines.length * 6 + 10;

      checkPageBreak(blockHeight);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(title, 14, y);
      y += 6;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);

      lines.forEach((line) => {
        checkPageBreak(8);
        doc.text(line, 14, y);
        y += 6;
      });

      y += 4;
    };

    // HEADER
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(student.Name || "Student Name", 14, y);
    y += 10;
/*
    addBlock(
      "Contact",
      `${student.Email || ""} ${student.Phone ? "| " + student.Phone : ""}`
    );
*/
    addBlock("Location", student.Location);
    addBlock("Profile", student.Domain);

    if (student.Skill) {
      addBlock(
        "Skills",
        student.Skill.split(",").map((s) => `• ${s.trim()}`).join("\n")
      );
    }

    addBlock("Education", student.Degree);
   // addBlock("Projects", student.Projects);

    if (summaries[index]) {
      addBlock("AI Summary", summaries[index]);
    }

    // ADDITIONAL DETAILS
    const exclude = [
      "Name",
      "Email",
      "Phone",
      "Location",
      "Domain",
      "Skill",
      "Degree",
      "Projects",
      "scrapedAt",
    ];

    const extras = Object.entries(student)
      .filter(([k, v]) => v && !exclude.includes(k))
      .map(([k, v]) => `${k}: ${v}`)
      .join("\n");

    if (extras) addBlock("Additional Details", extras);

    doc.save(`${student.Name || "resume"}.pdf`);
  };

  // ================= FILTER HANDLERS =================
  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchStudents();
  };

  const handleReset = () => {
    setDomain("");
    setSkill("");
    setDegree("");
    setLocation("");
    setPage(1);
    fetchStudents();
  };

  // ================= UI =================
  return (
    <div className="container">
      <h2 style={{ color: "navy" }}>U2U Placement Support Portal</h2>
      {/* SEARCH */}
      <form className="search-form" onSubmit={handleSearch}>
        <input
          placeholder="Domain"
          value={Domain}
          onChange={(e) => setDomain(e.target.value)}
        />

        <input
          placeholder="Skill"
          value={Skill}
          onChange={(e) => setSkill(e.target.value)}
        />

        <select value={Degree} onChange={(e) => setDegree(e.target.value)}>
          <option value="">All Degrees</option>
          {Degreees.map((d, i) => (
            <option key={i} value={d}>
              {d}
            </option>
          ))}
        </select>

        <select value={Location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">All Locations</option>
          {Locations.map((l, i) => (
            <option key={i} value={l}>
              {l}
            </option>
          ))}
        </select>

        <button type="submit">Search</button>
        <button type="button" onClick={handleReset}>
          Reset
        </button>
      </form>

      {/* STUDENT LIST */}
      <div className="student-list">
        {students.length === 0 ? (
          <p>No students found.</p>
        ) : (
          students.map((student, idx) => (
            <div key={idx} className="resume-card">

              {/* HEADER */}
              <div className="resume-header">
                <h2>{student.Name}</h2>
                <p>
                  {student.Email} {student.Phone && `| ${student.Phone}`}
                </p>
                <p>{student.Location}</p>
              </div>
           
  {/* ⭐ ATS SCORE DISPLAY */}
           {atsResults[idx] && (
  <div className="resume-section">

    <h3>ATS Score 1 (Resume Strength)</h3>
    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
      {atsResults[idx].score1} / 100
    </p>

    <ul>
      {(atsResults[idx].suggestions1 || []).map((s, i) => (
        <li key={`s1-${i}`}>{s}</li>
      ))}
    </ul>

    <hr />

  </div>
)}

              {/* AI SUMMARY */}
              {summaries[idx] && (
                <div className="resume-section">
                  <h3>AI Professional Summary</h3>
                  <p>{summaries[idx]}</p>
                </div>
              )}

              {/* FULL RESUME VIEW */}
              <div className="resume-section">
                <h3>Profile</h3>
                <p>{student.Domain}</p>
              </div>

              <div className="resume-section">
                <h3>Skills</h3>
                <p>{student.Skill}</p>
              </div>

              <div className="resume-section">
                <h3>Education</h3>
                <p>{student.Degree}</p>
              </div>

              {/* FULL RAW DATA */}
              <div className="resume-section">
                <h3>Complete Resume Details</h3>
                {Object.entries(student).map(([key, value]) => {
                  if (!value || key === "scrapedAt") return null;

                  return (
                    <p key={key}>
                      <strong>{key}:</strong> {value}
                    </p>
                  );
                })}
              </div>


{/* JOB DESCRIPTION */}
<div style={{ margin: "15px 0" }}>
  <h3>Job Description - Paste Job Description</h3>
  <textarea
    placeholder="Paste Job Description to calculate ATS Score..."
    value={jobDescription}
    onChange={(e) => setJobDescription(e.target.value)}
    style={{
      width: "100%",
      height: "120px",
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "6px",
    }}
  />
</div>
{/* ⭐ ATS SCORE DISPLAY */}
           {atsResults[idx] && (
  <div className="resume-section">
<h3>ATS Score 2 (Job Match)</h3>
    <p style={{ fontSize: "18px", fontWeight: "bold", color: "green" }}>
      {atsResults[idx].score2} / 100
    </p>

    <ul>
      {(atsResults[idx].suggestions2 || []).map((s, i) => (
        <li key={`s2-${i}`}>{s}</li>
      ))}
    </ul>
    <hr />
  </div>
)}
              {/* DOWNLOAD */}
              <button onClick={() => generatePDF(student, idx)}>
                Download Pdf Resume
              </button>
              <button
  onClick={() => downloadWord(student, idx)}
  style={{
    marginLeft: "10px",
    background: "green",
    color: "white",
  }}
>
  Download Word Resume
</button>

            </div>
          ))
        )}
      </div>
{/* ================= PAGINATION (BOTTOM FIXED) ================= */}
      <div className="pagination-footer">
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          ◀ Previous
        </button>

        <span style={{ margin: "0 15px" }}>
          Page {page} of {totalPages}
        </span>

        <button
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next ▶
        </button>
      </div>


    </div>
  );
}

//export default Dashboard;